import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import useJumpBackAndResetDeposit from '../../../../../../hooks/useJumpBackAndResetDeposit';
import Prompt from '../../../../../Prompt/Prompt';
import PaymentMethodDetailsSummary from '../../../PaymentMethodDetailsSummary/PaymentMethodDetailsSummary';

import {
  TXTWCL_By_selecting_another_payment_m_ELL,
  TXTWCL_Go_back,
  TXTWCL_Start_a_new_deposit,
  TXTWCL_Start_a_new_depositX,
  TXTWCL_Would_you_like_to_continue_and_ELL
} from './PaymentMethodSummary.messages.json';

const PaymentMethodSummary: React.FC = () => {
  const [changeMethodConfirmation, setChangeMethodConfirmation] = useState(false);
  const jumpBackAndResetDeposit = useJumpBackAndResetDeposit();

  const {
    values: {
      deposit: { type }
    }
  } = useWizardContext();

  return (
    <>
      <PaymentMethodDetailsSummary
        type={type}
        onEditCallback={() => setChangeMethodConfirmation(true)}
        variant="summary"
      />
      {changeMethodConfirmation && (
        <Prompt
          variant="info"
          title={{ translation: TXTWCL_Start_a_new_depositX }}
          primaryButton={{ translation: TXTWCL_Start_a_new_deposit }}
          secondaryButton={{ translation: TXTWCL_Go_back }}
          onPrimaryButtonClick={() => jumpBackAndResetDeposit('#deposit.deposit-method')}
          onClose={() => setChangeMethodConfirmation(false)}
          onSecondaryButtonClick={() => setChangeMethodConfirmation(false)}
        >
          <Translation tagName="p" {...TXTWCL_By_selecting_another_payment_m_ELL} />
          <Translation tagName="p" {...TXTWCL_Would_you_like_to_continue_and_ELL} />
        </Prompt>
      )}
    </>
  );
};

export default PaymentMethodSummary;
